import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      columnDateTime: formatMessage(messages.columnDateTime),
      columnCenter: formatMessage(messages.columnCenter),
      columnStatus: formatMessage(messages.columnStatus),
      columnCenterServices: formatMessage(messages.columnCenterServices),
      btnView: formatMessage(messages.btnView),
      statusCheckout: formatMessage(messages.statusCheckout),
      statusIncomplete: formatMessage(messages.statusIncomplete),
      statusAbandoned: formatMessage(messages.statusAbandoned),
      statusConfirmed: formatMessage(messages.statusConfirmed),
      statusCanceled: formatMessage(messages.statusCanceled),
      statusStudiesRead: formatMessage(messages.statusStudiesRead),
      statusStudiesUnread: formatMessage(messages.statusStudiesUnread),
      statusReportsSent: formatMessage(messages.statusReportsSent),
      statusReportsError: formatMessage(messages.statusReportsError),
      statusNoShow: formatMessage(messages.statusNoShow),
      statusIntakeComplete: formatMessage(messages.statusIntakeComplete),
      statusCheckedIn: formatMessage(messages.statusCheckedIn),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
